<agr-dialog class="observation-dialog" [data]="data" [formGroup]="form" (cancel)="cancel()">
  <ng-container details>
    <div class="flex--row">
      <div class="spacing--margin-right">
        <mat-chip-listbox>
          @for (cropFieldId of selectedCropFieldIds(); track cropFieldId) {
            <mat-chip-option [selectable]="false" (removed)="removeCropField(cropFieldId)">
              <b>{{ getCropFieldName(cropFieldId) }}</b> {{ getCropFieldArea(cropFieldId) }} ha
              @if (!isReadonlyMode && selectedCropFieldIds().length > 1) {
                <mat-icon matChipRemove data-test="crop-remove">cancel</mat-icon>
              }
            </mat-chip-option>
          }
        </mat-chip-listbox>
      </div>
    </div>
  </ng-container>

  <div class="dialog spacing--margin-top">
    <div class="text--bold spacing--margin-half-bottom">
      {{ 'downyMildew.observation.addSectionTitle' | translate }}
    </div>

    <div class="flex--row flex--gutter spacing--margin-half-top">
      <div class="flex__child">
        <mat-form-field class="full-width-field" data-test="observation-date">
          <mat-label>{{ 'downyMildew.observation.date' | translate }}</mat-label>
          <input
            matInput
            formControlName="date"
            [matDatepicker]="observationDatePicker"
            [max]="maxDate"
            [placeholder]="'downyMildew.observation.date' | translate"
            [errorStateMatcher]="dateErrorStateMatcher"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="observationDatePicker"
            [disabled]="isReadonlyMode"
          ></mat-datepicker-toggle>
          <mat-datepicker #observationDatePicker></mat-datepicker>
          @if (form.controls.date.hasError('matDatepickerMax')) {
            <mat-error data-test="observation-date-future-error">{{
              'downyMildew.observation.dateInFuture' | translate
            }}</mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="spacing--margin-top" data-test="observation-severity">
      <div class="severity-header">
        <span class="text--bold">{{ 'downyMildew.observation.severity' | translate }}</span>
      </div>

      <mat-radio-group formControlName="severity" class="severity-radio-group">
        @for (severity of severityLevels; track severity) {
          <div class="severity-option">
            <mat-radio-button [value]="severity" class="severity-radio-option" color="primary">
              {{ 'downyMildew.observation.severityLevels.' + severity | translate }}
            </mat-radio-button>
            <button
              mat-icon-button
              type="button"
              class="info-button"
              (click)="onObservationInfoClicked(severity)"
              [matTooltip]="'downyMildew.observation.showExampleImage' | translate"
              [attr.aria-label]="'downyMildew.observation.showExampleImage' | translate"
            >
              <mat-icon>info_outline</mat-icon>
            </button>
          </div>
        }
      </mat-radio-group>
    </div>

    <span [matTooltip]="'UI.CurrentYearOnlyMutationMessage' | translate" [matTooltipDisabled]="!isReadonlyMode">
      <button
        mat-flat-button
        color="accent"
        data-test="submit-observation"
        type="button"
        (click)="submitObservation()"
        [disabled]="isSubmitDisabled"
        class="spacing--margin-top spacing--margin-half-right"
      >
        @if (isSubmitting) {
          <mat-icon class="spinner">autorenew</mat-icon>
        }
        <mat-icon>add</mat-icon>
        {{ 'add' | translate }}
      </button>
    </span>

    <mat-divider class="section-divider spacing--margin-top"></mat-divider>

    <div class="observation-history-section spacing--margin-top">
      <div class="text--bold spacing--margin-half-bottom">
        {{ 'downyMildew.observationHistory.title' | translate }}
      </div>
      <app-observation-history
        [registrations]="downyMildewStore.observationHistoryValue()"
        [cropFields]="selectedCropFieldInfos"
        [isLoading]="downyMildewStore.observationHistoryIsLoading()"
        [readOnly]="isReadonlyMode"
        (removeRegistration)="onRemoveObservation($event)"
      />
    </div>
  </div>
</agr-dialog>
